<template>
  <div class="container">
    <b-form @submit="">
      <b-form-group
        id="input-group-1"
        label="Email address:"
        label-for="input-1"
        class="left"
      >
        <b-form-input
          id="input-1"
          required
          placeholder="Enter email"
        ></b-form-input>
      </b-form-group>

      <div class="form-group left">
        <label>产品名称:</label>
        <div class="form-inline">
          <b-form-input
            name="storagename"
            type="text"
            class="form-control"
            placeholder="请输入产品名称"
            style="width: auto"
          ></b-form-input>
          <b-button variant="success" class="smsBtn">获取</b-button>
        </div>
      </div>
      <div align="center">
        <b-button blocks variant="success" style="width: 80%">查询</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "Test",
  data() {
    return {};
  },
};
</script>

<style scoped>
.left {
  text-align: left;
}

.smsBtn {
  margin-left: 8px;
}

.container {
  padding-left: 16px;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Test.vue